import { Component, OnInit, Input } from '@angular/core';
import { UpgradeAction } from '@models/upgradePlan.model';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LocationsFacadeService } from '@services/locations/locations-facade.service';
import { MessageService } from 'primeng/api';
import { Subscription } from 'rxjs';
import Swal from 'sweetalert2';
import { UpgradeFeatureModalComponent } from '../upgrade-feature-modal/upgrade-feature-modal.component';

@Component({
  selector: 'zapier-upgrade',
  templateUrl: './zapier-upgrade.component.html',
  styleUrls: ['./zapier-upgrade.component.sass']
})
export class ZapierUpgradeComponent implements OnInit {
  @Input() zapierKey: string;
  @Input() isZapierEnabled: boolean;
  @Input() isEnabledUpgradeModal: boolean;
  _subs: Subscription = new Subscription();
  bodyText: string = "Learn more about this feature";
  bodyTextLink: string = "https://help.getmorereviews.com/en/articles/4109024-zapier-integration-guide-how-to-automate-review-request-sending";

  constructor(
    private messageToast: MessageService,
    private modalService: NgbModal,
    private locationsFacadeService: LocationsFacadeService,
  ) { }

  ngOnInit() {
    if (!this.isZapierEnabled) {
      if (this.isEnabledUpgradeModal) {
       this.bodyText = "Learn more about this feature";
       this.bodyTextLink = "https://help.getmorereviews.com/en/articles/4109024-zapier-integration-guide-how-to-automate-review-request-sending";
      } else {
        this.bodyText = "To add Automations/Integrations feature to your plan, contact Support";
        this.bodyTextLink = "";
      }
    }
  }

  showModalInfo() {
    Swal.fire({
      title: 'Upgrade to Add Automations/Integrations',
      text: 'To add Automations/Integrations feature to your plan, contact Support',
      icon: 'info',
      showCancelButton: false,
      confirmButtonText: 'Ok!'
    })
  }
  // openUpgradeFeatureModal() {
  //   const modalRef = this.modalService.open(UpgradeFeatureModalComponent, { centered: true, backdrop: 'static', keyboard: false });
  //   modalRef.componentInstance.title = "Upgrade to Add Automations/Integrations";
  //   modalRef.componentInstance.bodyText = "Learn more about this feature";
  //   modalRef.componentInstance.bodyTextLink = "https://help.getmorereviews.com/en/articles/4109024-zapier-integration-guide-how-to-automate-review-request-sending";
  //   //subscribe to child output event
  //   this._subs.add(
  //     modalRef.componentInstance.addOnEmit
  //       .subscribe(val => {
  //         this.locationsFacadeService.upgradePlan({ action: UpgradeAction.ZAPIER, cancelFeatureButton: "" })
  //       })
  //   )
  //   this._subs.add(
  //     modalRef.componentInstance.upgradePlanEmit
  //       .subscribe(val => {
  //         this.locationsFacadeService.upgradePlan({ action: UpgradeAction.UPGRADE_ALL, cancelFeatureButton: "" })
  //       })
  //   )
  //   this._subs.add(
  //     modalRef.componentInstance.cancelEmit
  //       .subscribe(val => {
  //         this.locationsFacadeService.upgradePlan({ action: UpgradeAction.CANCEL, cancelFeatureButton: "Automations/Integrations" })
  //       })
  //   )
  // }
  addOn() {
    this.locationsFacadeService.upgradePlan({ action: UpgradeAction.ZAPIER, cancelFeatureButton: "" })
  }

  cancel() {
    this.locationsFacadeService.upgradePlan({ action: UpgradeAction.CANCEL, cancelFeatureButton: "Automations/Integrations" })
  }
  ngOnDestroy(): void {
    if (this._subs) this._subs.unsubscribe()
  }
}
